module.exports = __webpack_public_path__ + "static/media/404.d67b186e.png";